import React, { Suspense } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

function SuspenseFallback (props) {
  return (
    <Suspense
      fallback={
        <CircularProgress
          color='secondary'
          size={40}
        />
      }
      {...props}
    />
  )
}

export default SuspenseFallback
